import { WashStage } from "@/core/api/generated/v1";

export class WashHelper {
  public static humanizeWashStage(stage?: WashStage) {
    switch (stage) {
      case WashStage.None: {
        return "None";
      }
      case WashStage.Draft: {
        return "Draft";
      }
      case WashStage.InProgress: {
        return "In progress";
      }
      case WashStage.Completed: {
        return "Completed";
      }
      default: {
        return "-";
      }
    }
  }
}
